/*	MARK: Ai5 Datasets management
	Display user's datasets
	============================================
 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';

const DatasetType = { Source:"source", Synthetic:"synthetic", Hybrid:"hybrid"};

@inject(DataService, Api, Router)
export class Datasets {
	/** Component methods **/
	constructor(ds, api, router){
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		this.selectedDataset = null;
		this.editDataset	 = null;
		this.DatasetType	 = DatasetType;
	}

	activate(params){ this.id = params.uid }

	attached(){
		window.setTimeout( () => { this.init(); }, 300);
	}

	init(){
		// Get datasets from DataService
		let datasets = this.ds.app_data.datasets;
		if(!datasets){
			this.getUserDatasets().then(response =>{
				this.handleResponseUserDatasets(response);
			});
		}
		else{
			this.datasets = datasets;
		}
	}

	/**	API Calls
		============================================
	 **/
	getUserDatasets(){
		let uid 	= this.ds.user.uid;
		let request = new Request("/api/v2/users/" +uid+ "/datasets/", "GET");
		return this.api.get(request);
	}

	handleResponseUserDatasets(response){

		let status = response.status;
		if(status === 200){
			let datasets 	= response.data;
			this.datasets 	=  datasets;
			this.ds.app_data.datasets = datasets;
		}
	}

	deleteDataset(id){
		// Request
		let request 	= new Request("/api/v2/datasets/id/_id?", "DELETE");
		let params  	= new URLSearchParams({ _id:id });
		request.url 	= request.url + params;
		return this.api.remove(request);
	}

	handleDeleteDataset(response){
		// Remove dataset
		let index = this.datasets.indexOf(this.editDataset)
		this.datasets.splice(index, 1);
	}

	postSummaryDataset(dataset){
		let id		= dataset._id;
		let req 	= new Request( "/api/v2/summary/","POST");
		let body 	= { dataset:dataset };
		req.body 	= JSON.stringify(body)
		// POST summary
		return this.api.post(req);
	}

	/** generate synthetic dataset **/
	postSyntheticDataset(req){
		/*	============================================
			Post synthetic dataset
			route => /api/v2/datasets/synthetic/
		*/
		// Create request
		let request 	= new Request("/api/v2/datasets/synthetic/", "POST");
		// Copy machine
		let req_machine	= { ... req.machine };
		// Edit machine
		req_machine.algorithm = "gen_synthetic_dataset"
		let body		= { machine:req_machine, dataset:req.dataset, oper:"gen_synthetic_dataset" };
		// Stringify req-body
		request.body	= JSON.stringify(body);
		return this.api.post(request);
	}

	handlePostSyntheticDataset(response){
		//console.log("response => ", response.data.dataset);
		return response;
	}

	/**	Custom methods
		============================================
	 **/
	newDataset(){
		//console.log("uid => ", this.id);
		this.router.navigateToRoute('datasets.create-dataset', { uid:this.id });
	}


	removeDataset(dataset){
		let dataset_id = dataset._id;
		this.deleteDataset(dataset_id).then(response => {
			this.handleDeleteDataset(response);
		});
	}

	onSelectDatasetMenu(dataset){
		this.editDataset = dataset;
	}

	/** Helper functions **/
	formatBytes(bytes, decimals = 2) {
		if (!+bytes) return '0 Bytes'
		const k = 1024
		const dm = decimals < 0 ? 0 : decimals
		const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		const i = Math.floor(Math.log(bytes) / Math.log(k))
		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
	}

	

	/*	Modal functions
		============================================
	 */

	/* 	Update datasets
		============================================
		Push new dataset to list
		[ this.datasets -> Array ]
	 */
	insertNewDataset(dataset){
		// this.datasets.push(dataset);
		this.datasets = [dataset, ...this.datasets].reverse();
	}

	// Generate synthetic dataset 
	generateSyntheticDataset(dataset){
		// Buffer machine
		let machine = { dataset:dataset.file_name, stats:{} };
		// Create synthetic data document
		let synth_document = { ... dataset}
		// Remove summary
		delete synth_document["summary"];
		let request = { machine:machine, dataset:synth_document };
		// console.log("request dataset: ", request.dataset);
		this.postSyntheticDataset(request).then(response => {
			return this.handlePostSyntheticDataset(response)
		})
		.then(res => {
			// Update UI datasets
			let data 	= res.data
			let dataset = data.dataset;
			this.insertNewDataset(dataset);
			// Summary
			this.postSummaryDataset(dataset);
		});
	}
}
